<template>
    <el-dialog :title="$t('editActivity')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               custom-class="medium-dialog">
        <div class="content">
            <el-form :model="formData"
                     size="mini"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="110px">
                <el-form-item :label="$t('activityName')"
                              prop="name">
                    <el-input v-model="formData.name"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('activityTime')" prop="date">
                    <el-date-picker
                        v-model="formData.date"
                        type="datetimerange"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="-"
                        :start-placeholder="$t('startTime')"
                        :end-placeholder="$t('endTime')"
                        :clearable="false"
                        time-arrow-control
                        @change="activityTimeChange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('lotteryTime')" prop="luckyDrawAt">
                    <el-date-picker
                        v-model="formData.luckyDrawAt"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :clearable="false"
                        time-arrow-control
                        :placeholder="$t('pleaseSelectHint')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('lotteryDuration')"
                              prop="durationTime">
                    <el-input
                        v-model="formData.durationTime"
                        autocomplete="off" v-input-integer>
                        <template slot="append">h</template>
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('whetherEnable')"
                              prop="enabled">
                    <el-switch
                        v-model="formData.enabled"
                        active-color="#13ce66"
                        inactive-color="#dcdfe6">
                    </el-switch>
                </el-form-item>
                <el-form-item :label="$t('remark')"
                              prop="remark">
                    <el-input
                        type="textarea"
                        v-model="formData.remark"
                        autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button
                size="mini" @click="dialogVisible = false">{{ $t('cancel') }}
            </el-button>
            <el-button type="primary"
                       size="mini"
                       :disabled="disabled"
                       @click="submitForm('ruleForm')">{{ $t('confirm') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import {
    updateLotteryActivity,
    queryLotteryActivityDetails
} from "@/api/modules/api";

export default {
    name: 'Edit',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    data () {
        let validatorLuckyDrawAt= (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('pleaseSelectHint')));
            }
            if (this.formData.date instanceof Array && this.formData.date.length === 2) {
                if (new Date(value).getTime() < new Date(this.formData.date[1]).getTime()) {
                    callback(new Error(this.$t('timeDiffHint')));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        }
        return {
            dialogVisible: false,
            formData: {
                name: '',
                date: [],
                luckyDrawAt: '',
                durationTime: '',
                enabled: true,
                remark: ''
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                date: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                luckyDrawAt: [{ required: true, validator: validatorLuckyDrawAt, trigger: 'change' }],
                durationTime: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                enabled: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
            },
            disabled: false,
        }
    },
    created () { },
    mounted () { },
    components: {},
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            // 获取详情
            this.getDetails()
        },
        
        // 获取详情
        getDetails () {
            queryLotteryActivityDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    // 活动时间
                    let date = []
                    let startedAt = this.$moment(resData.startedAt).format('YYYY-MM-DD HH:mm:ss')
                    let endedAt = this.$moment(resData.endedAt).format('YYYY-MM-DD HH:mm:ss')
                    if (startedAt && endedAt) {
                        date[0] = startedAt
                        date[1] = endedAt
                    }
                    // 抽奖时间
                    let luckyDrawAt = this.$moment(resData.luckyDrawAt).format('YYYY-MM-DD HH:mm:ss')
                    this.formData = {
                        name: resData.name,
                        date,
                        luckyDrawAt,
                        durationTime: resData.durationTime,
                        enabled: resData.enabled,
                        remark: resData.remark
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
    
        // 活动时间变化
        activityTimeChange (value) {
            if (value instanceof Array && value.length === 2 && this.formData.luckyDrawAt) {
                this.$refs.ruleForm.validateField('luckyDrawAt')
            }
        },
        
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            // 活动时间
            let date = this.formData.date
            let startedAt = ''
            let endedAt = ''
            if (date instanceof Array && date.length === 2) {
                startedAt = this.$moment(date[0]).format('YYYY-MM-DDTHH:mm:ssZZ')
                endedAt = this.$moment(date[1]).format('YYYY-MM-DDTHH:mm:ssZZ')
            }
            // 抽奖时间
            let luckyDrawAt = ''
            if (this.formData.luckyDrawAt) {
                luckyDrawAt = this.$moment(this.formData.luckyDrawAt).format('YYYY-MM-DDTHH:mm:ssZZ')
            }
            // 比较活动时间和抽奖时间
            const diff = this.$moment(luckyDrawAt).diff(this.$moment(endedAt), 'seconds')
            if (diff < 0) {
                this.$message({
                    showClose: true,
                    message: this.$t('timeDiffHint'),
                    type: 'warning'
                })
                return
            }
            const params = {
                id: this.parentId,
                name: this.formData.name.trim(),
                startedAt,
                endedAt,
                luckyDrawAt,
                durationTime: this.formData.durationTime,
                enabled: this.formData.enabled,
                remark: this.formData.remark
            }
            this.disabled = true;
            updateLotteryActivity(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
.content{
    max-height: 620px;
    overflow-y: auto;
}
</style>
